import {
  IconAuto,
  IconBusinessOwnersPolicy,
  IconCommercialAuto,
  IconContractor,
  IconDocumentMulti,
  IconFarm,
  IconGarage,
  IconGeneralLiability,
  IconInlandMarine,
  IconMotorcycleAccessories,
  IconPeople,
  IconPrinter,
  IconProperty,
  IconQuestionMark,
  IconUmbrella,
  IconWorkersComp,
} from '@lmig/lmds-react-icons';
import { isProd } from 'Foundation/Configurations/GlobalConfiguration';
import type { ReactNode } from 'react';

enum LOBPrefix {
  eCLIQSimpleAuto = 'AZ',
  BusinessAuto = 'BA',
  LiquorLiability = 'BD',
  CommercialProperty = 'BF',
  ContractorsLiability = 'BH',
  EmployeeBenefitsLiability = 'BI',
  MultiPeril = 'BK',
  GeneralLiability = 'BL',
  InlandMarine = 'BM',
  GarageLiability = 'BN',
  BusinessOwners = 'BZ',
  eCLIQSimpleBOP = 'BW',
  SupportedLeadExcess = 'ES',
  FarmLiability = 'FG',
  FarmProperty = 'FF',
  PrintersEO = 'PP',
  CommercialUmbrella = 'US',
  SpeciltyExcess = 'EC',
  SpecialtyUmbrella = 'EU',
  FarmPackage = 'FM',
  eCLIQSimpleMotorCargo = 'IM',
  UnsupportedLeadUmbrella = 'UU',
  WorkersCompensation = 'XW',
}

const LOBIconConversion: Record<LOBPrefix, React.ReactNode> = {
  [LOBPrefix.eCLIQSimpleAuto]: <IconAuto size="16" />,
  [LOBPrefix.BusinessAuto]: <IconCommercialAuto size="16" />,
  [LOBPrefix.LiquorLiability]: <IconWorkersComp size="16" />,
  [LOBPrefix.CommercialProperty]: <IconProperty size="16" />,
  [LOBPrefix.ContractorsLiability]: <IconContractor size="16" />,
  [LOBPrefix.EmployeeBenefitsLiability]: <IconPeople size="16" />,
  [LOBPrefix.MultiPeril]: <IconDocumentMulti size="16" />,
  [LOBPrefix.GeneralLiability]: <IconGeneralLiability size="16" />,
  [LOBPrefix.InlandMarine]: <IconInlandMarine size="16" />,
  [LOBPrefix.GarageLiability]: <IconGarage size="16" />,
  [LOBPrefix.BusinessOwners]: <IconBusinessOwnersPolicy size="16" />,
  [LOBPrefix.eCLIQSimpleBOP]: <IconBusinessOwnersPolicy size="16" />,
  [LOBPrefix.SupportedLeadExcess]: <IconWorkersComp size="16" />,
  [LOBPrefix.FarmLiability]: <IconFarm size="16" />,
  [LOBPrefix.FarmProperty]: <IconFarm size="16" />,
  [LOBPrefix.PrintersEO]: <IconPrinter size="16" />,
  [LOBPrefix.CommercialUmbrella]: <IconUmbrella size="16" />,
  [LOBPrefix.SpeciltyExcess]: <IconWorkersComp size="16" />,
  [LOBPrefix.SpecialtyUmbrella]: <IconUmbrella size="16" />,
  [LOBPrefix.FarmPackage]: <IconUmbrella size="16" />,
  [LOBPrefix.eCLIQSimpleMotorCargo]: <IconMotorcycleAccessories size="16" />,
  [LOBPrefix.UnsupportedLeadUmbrella]: <IconUmbrella size="16" />,
  [LOBPrefix.WorkersCompensation]: <IconWorkersComp size="16" />,
};

const LOBNameConversion: Record<LOBPrefix, string> = {
  [LOBPrefix.eCLIQSimpleAuto]: 'eCLIQ Simple Auto',
  [LOBPrefix.BusinessAuto]: 'Business Auto',
  [LOBPrefix.LiquorLiability]: 'Liquor Liability',
  [LOBPrefix.CommercialProperty]: 'Commercial Property',
  [LOBPrefix.ContractorsLiability]: 'Contractors Liability',
  [LOBPrefix.EmployeeBenefitsLiability]: 'Employee Benefits Liability',
  [LOBPrefix.MultiPeril]: 'Multi-Peril',
  [LOBPrefix.GeneralLiability]: 'General Liability',
  [LOBPrefix.InlandMarine]: 'Inland Marine',
  [LOBPrefix.GarageLiability]: 'Garage Liability',
  [LOBPrefix.BusinessOwners]: 'Business Owners',
  [LOBPrefix.eCLIQSimpleBOP]: 'eCLIQ Simple BOP',
  [LOBPrefix.SupportedLeadExcess]: 'Supported Lead Excess',
  [LOBPrefix.FarmLiability]: 'Farm Liability',
  [LOBPrefix.FarmProperty]: 'Farm Property',
  [LOBPrefix.PrintersEO]: 'Printers E & O',
  [LOBPrefix.CommercialUmbrella]: 'Commercial Umbrella',
  [LOBPrefix.SpeciltyExcess]: 'Specialty Excess',
  [LOBPrefix.SpecialtyUmbrella]: 'Specialty Umbrella',
  [LOBPrefix.FarmPackage]: 'Farm Package',
  [LOBPrefix.eCLIQSimpleMotorCargo]: 'eCLIQ Simple Motor Cargo',
  [LOBPrefix.UnsupportedLeadUmbrella]: 'Unsupported Lead Umbrella',
  [LOBPrefix.WorkersCompensation]: 'Workers Compensation',
};

export const GetLOBIconFromPolicy = (policyNumber: string) => {
  var icon: ReactNode = <></>;
  try {
    const policyPrefix = policyNumber.slice(0, 2);
    if (policyPrefix.length > 1) icon = LOBIconConversion[policyPrefix as LOBPrefix];
  } catch (e) {}
  if (!icon && !isProd()) icon = <IconQuestionMark size="16" />;
  return icon;
};

export const GetLOBNameFromPolicy = (policyNumber: string) => {
  var LOB: string = '';
  try {
    const policyPrefix = policyNumber.slice(0, 2);
    if (policyPrefix.length > 1) LOB = LOBNameConversion[policyPrefix as LOBPrefix];
  } catch (e) {}
  return LOB;
};
